export const urls = {
  GET_DNEVNIK:
    'DnevnaEvidencija/vrati_dnevne_evidenciju_za_idDok_radnog_naloga_web',
  GET_IZVESTAJ_SA_TERENA: 'DnevnaEvidencija/masine_dnevnik_izvestaj_sa_terena',
  GET_BAZA_ZNANJA: 'DnevnaEvidencija/masine_dnevnik_baza_znanja',
};
